class NavigationFlyout extends HTMLElement {
  connectedCallback() {
    this.panel = this.closest('.xm-flyout-submenu');
    this.item = this.closest('.menu-list__list-item');
    this.topLink = this.item.querySelector('[ref="menuitem"]');
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.item.addEventListener('pointerenter', () => this.position(), options);
    this.item.addEventListener('focusin', () => this.position(), options);
    this.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const category = event.target.closest('[data-category]');
      if (category && !category.contains(event.relatedTarget)) this.select(category);
    }, options);
    this.addEventListener('focusin', (event) => {
      const category = event.target.closest('[data-category]');
      if (category) this.select(category);
    }, options);
    this.addEventListener('click', (event) => {
      const category = event.target.closest('[aria-controls][data-category]');
      if (category && !matchMedia('(hover:hover) and (pointer:fine)').matches && category.ariaExpanded !== 'true') {
        event.preventDefault();
        this.select(category);
      }
    }, options);
    this.addEventListener('keydown', (event) => {
      const category = event.target.closest('[data-category]');
      if (event.key === 'ArrowRight' && category?.hasAttribute('aria-controls')) {
        event.preventDefault();
        this.select(category);
        this.querySelector('[data-panel]:not([hidden]) a')?.focus();
      } else if (event.key === 'ArrowLeft' && !category) {
        event.preventDefault();
        this.querySelector('[data-category][data-active]')?.focus();
      }
    }, options);
    window.addEventListener('resize', () => this.position(), options);
    window.addEventListener('scroll', (event) => {
      if (!this.contains(event.target)) this.position();
    }, { ...options, capture: true, passive: true });
    this.position();
  }
  disconnectedCallback() { this.abort?.abort(); }
  select(category) {
    for (const link of this.querySelectorAll('[data-category]')) {
      const active = link === category;
      link.toggleAttribute('data-active', active);
      if (link.hasAttribute('aria-controls')) link.ariaExpanded = String(active);
    }
    let expanded = false;
    for (const panel of this.querySelectorAll('[data-panel]')) {
      panel.hidden = panel.dataset.panel !== category.dataset.category;
      if (!panel.hidden) expanded = true;
    }
    this.toggleAttribute('data-expanded', expanded);
    this.position();
  }
  position() {
    if (!this.topLink || !matchMedia('(min-width:750px)').matches) return;
    const overflow = this.item.getAttribute('slot') === 'overflow';
    const rect = (overflow ? this.topLink : this.item).getBoundingClientRect();
    const origin = this.panel.offsetParent?.getBoundingClientRect() || rect;
    const style = getComputedStyle(this);
    const leftWidth = parseFloat(style.getPropertyValue('--xf-left')) || 300;
    const rightWidth = parseFloat(style.getPropertyValue('--xf-right')) || 360;
    const width = Math.min(leftWidth + (this.hasAttribute('data-expanded') ? rightWidth : 0), innerWidth - 24);
    const preferredX = overflow ? rect.right : rect.left;
    const x = Math.max(12, Math.min(preferredX, innerWidth - width - 12)) - origin.left;
    const y = overflow ? rect.top : rect.bottom;
    this.panel.style.setProperty('--xf-width', width + 'px');
    this.panel.style.setProperty('--xf-x', x + 'px');
    this.panel.style.setProperty('--xf-y', (y - origin.top) + 'px');
    this.style.setProperty('--xf-max-height', Math.max(80, innerHeight - y - 16) + 'px');
  }
}
if (!customElements.get('xm-navigation-flyout')) customElements.define('xm-navigation-flyout', NavigationFlyout);

